import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// images
import SocialLoginStrokeImage from "../../images/pages/signinpage/signin-stroke.svg";
import IconFacebook from "../../images/pages/signinpage/icon_Facebook.svg";
import IconApple from "../../images/pages/signinpage/icon_apple.svg";
import IconGoogle from "../../images/pages/signinpage/icon_google.svg";

// components
import CommonInput from "../../components/input/CommonInput";

// validation
import { validationEmailFunc, validationFunc } from "../../validation/validation";

// api
import { signup, verifyEmail } from "../../services/api/user";


function SignUpPage() {
    const navigate = useNavigate();

    const [input, setInput] = useState({
        email: "",
        name: "",
        password: ""
    })

    const [validation, setValidation] = useState({
        email:false,
        name:false,
        password:false
    })

    const [existEmail, setExistEmail] = useState(false);

    const handleInput = (value, type) => {
        if(type==="email"){
            setValidation({
                ...validation,
                email: validationEmailFunc(value)
            });
            setExistEmail(false);
        }else if(type==="name"){
            setValidation({
                ...validation,
                name: validationFunc({ input:value, maxLength:10 })
            })
        }else if(type==="password"){
            setValidation({
                ...validation,
                password: validationFunc({ input:value, minLength:8, isNumber:true, isAlphabet:true, isSpecChars:true, isPassword:true})
            })
        }

        setInput({
            ...input,
            [type]: value
        })
    }

    const handleSignUp = async (event) => {
        event.preventDefault();

        setInput({
            email: input.email.trim(),
            password: input.password.trim(),
            name: input.name.trim()
        })

        try{
            const res = await signup({
                username: input.email.trim(),
                password: input.password.trim(),
                name: input.name.trim()
            })

            try{                
                navigate("/sign-up/verification-email", { state: input.email.trim()});
            }catch(err){
                console.error(err);
                if(err.response){
                    alert(err.response.data.message);
                }                
            }
            
        }catch(err){
            console.error(err);

            if(err.response && err.response.status===400) {
                if(err.response.data.message==="exists-username"){
                    setExistEmail(true);
                }else if(err.response.data.message==="unverified-username"){
                    try{
                        const emailRes = await verifyEmail(input.email.trim());
        
                        navigate("/sign-up/verification-email", { state: input.email.trim()});
                    }catch(err){
                        console.error(err);
                        if(err.response){
                            alert(err.response.data.message);
                        }                
                    }
                }
            }
        }        
    }

    return (
        <div className="SignUpPage">
            <form onSubmit={handleSignUp} noValidate>
                <CommonInput
                    type="email"
                    legend="E-mail"
                    placeholder="Enter your e-mail."
                    handleInput={handleInput}
                    input={input}
                    checkvalid={true}
                    validation={validation.email}
                    existEmail={existEmail}
                />
                <CommonInput
                    type="name"
                    legend="Name"
                    placeholder="Enter your name."
                    handleInput={handleInput}
                    input={input}
                    description="Names can be up to 10 characters long."
                    checkvalid={true}
                    validation={validation.name}
                />
                <CommonInput
                    type="password"
                    legend="Password"
                    placeholder="Enter your password."
                    handleInput={handleInput}
                    input={input}
                    description={`Passwords must meet the following criteria: 8+ digits / contain numbers / contain alphanumeric characters / contain special characters (except \\ ").`}
                    checkvalid={true}
                    validation={validation.password}
                />

                <button className="SignUpButton" type="submit" disabled={existEmail || !(validation.email && validation.name && validation.password)}>Next</button>
            </form>
            {/* <div className="SocialLogin">
                <div className="SocialLogin-Stroke">
                    <img src={SocialLoginStrokeImage} alt="social login stroke" />
                    <div>or</div>
                    <img src={SocialLoginStrokeImage} alt="social login stroke" />
                </div>
                <div className="IconGroup">
                    <button>
                        <img src={IconFacebook} alt="facebook social login icon" />
                    </button>
                    <button>
                        <img src={IconApple} alt="apple social login icon" />
                    </button>
                    <button>
                        <img src={IconGoogle} alt="google social login icon" />
                    </button>
                </div>
            </div> */}
            <div className="Policy">
                By signing up to creat an account i accept Company's <Link to="/" style={{pointerEvents: 'none'}}>Terms of Use and Privacy Policy.</Link>
            </div>
        </div>
    );
}

export default SignUpPage;